import { groq } from 'next-sanity';
import { z } from 'zod';

import { openGraphImageField, SanityImage } from './image';
import { SanityPageSection } from './sections';
import { sectionsWithReference } from './sectionsWithReference';

export const SanityPage = z.object({
  _id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  openGraphTitle: z.string().nullable(),
  openGraphDescription: z.string().nullable(),
  openGraphImage: SanityImage.nullable(),
  deIndex: z.boolean().nullable(),
  slug: z.string(),
  sections: SanityPageSection.array().optional().nullable(),
  menuBarStyle: z.enum(['default', 'hidden']),
  footerStyle: z.enum(['full', 'compact']),
});
export type SanityPage = z.infer<typeof SanityPage>;

export const page = groq`{
  _id,
  title,
  description,
  openGraphTitle,
  "deIndex": coalesce(deIndex, false),
  openGraphDescription,
  ${openGraphImageField},
  'slug': slug.current,
  sections[] ${sectionsWithReference},
 'menuBarStyle': coalesce(menuBarStyle, 'default'),
 'footerStyle': 'full',
}`;
